import { cardRecipe } from "./card.recipe";
import { tabsRecipe } from "./tabs.recipe";
import { toastSlotRecipe } from "./toaster.recipe";

export const slotRecipes = {
  card: cardRecipe,
  tabs: tabsRecipe,
  toast: toastSlotRecipe,
};
